import {gql} from '@apollo/client/core';
import {PriceTableFragment} from './price-table.fragment';
import {ProductAllMetaFragment} from './product-all-meta.fragment';


export const ProductDataFragment = gql`
  fragment productData on WineProduct {
    id
    inStock
    defaultQuantity
    preorderDate
    canBeAddedToCart
    nodePath
    ctaLink
    pageWhitelist
    ctaTitle
    ctaStockText
    isB2b
    vimeoId
    youTubeId
    hideDiscountCountdown
    title
    body
    supplierName
    pdfText
    vismaProductNumber
    sku
    vismaSku
    has360BottleImage
    packaging
    closure
    shortText
    hidePriceTable
    hideShippingCountdown
    hideSupervinAdvantages
    productDescription
    tastingNotesDescription
    productionMethodDescription
    producerDescription
    highlightText
    videoLink
    topCta {
      text
      icon
      type
    }
    isLeftover
    isEnPrimeur
    customBadgeHTML
    productImageBadge {
      type
      value
      text
      badgeColor
      textColor
    }
    images {
      id
      large
      height
      width
      small
      roles
    }
    image {
      id
      original
      large
      small
      thumbnail
      height
      width
    }
    productAuthor {
      id
      name
      tagline
      image
    }
    tags {
      altText
      color
      icon
      text
      type
    }
    priceTable {
      ...priceTable
    }
    meta {
      ...productAllMeta
    }
    suggestedRetailPrice
    __typename
  }
  ${PriceTableFragment}
  ${ProductAllMetaFragment}
`;
